import classNames from "classnames";
import styles from "./index.module.scss";
import { Info } from "../../components/Icons/general-interface-1";

type PropsType = {
  field: string;
  children: string;
  className?: string;
};

/**
 * className="position: absolute" for error messages without shifting doc
 */
const ErrorMessage = ({ field, children, className }: PropsType) => {
  return (
    <div
      className={classNames(styles.errorMessage, className)}
      aria-live="polite"
      id={`${field}Message`}
    >
      <Info className={styles.icon} />
      <div className={styles.message}>{children}</div>
    </div>
  );
};

export default ErrorMessage;
